// Canonical English string keys used by t(). Translators receive this file
// (Operations Panel -> Translations -> Download English template), translate the values,
// and the file is uploaded back — no code changes needed.
export const I18N_KEYS = [
  "Log out",
  "Coin sounds",
  "On",
  "Off",
  "Operations Panel",
  "Student sign-in sandbox",
  "Language",
  "Hey,",
  "Pick up where you left off.",
  "Build your first streak today.",
  "Lessons done",
  "lessons",
  "Start quiz",
  "Locked",
  "Already done — you can take it again any time.",
  "Submit answers",
  "Submitting...",
  "Retry quiz",
  "Come back later",
  "Mark complete",
  "Saving...",
  "Prev",
  "Next",
  "Log in",
  "Checking...",
  "First name",
  "Last name",
  "Forgot your ID?",
  "Find",
  "Your first name",
  "Your last name",
  "Here is your Student ID",
  "Your ID",
  "Continue",
];
